import React from 'react'

const prague = {
    id:  'prague',
    type: 'post',
    countryId: 'easternEurope',
    title: 'A Chill Week in Prague',
    longDate: 'July 2, 2019',
    month: 'July',
    date: '2',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/praguecover.jpg',
    content: [
        {
            text: (
                <div>When I heard my friend Monica was returning to Prague for the summer after spending a month there in October and loving it, I immediately bought tickets to go visit for a week. I’ve been to Prague three times before, but never exceeded 48 hours in the city – only passed through in a whirlwind, visiting the synagogue museums and staying entirely in the Old Town. With Monica there as a local guide, we planned for a week of working our 9-5's and exploring the city in the evenings.</div>
            )
        },
        {
            text: (
                <div>As it turned out, most of our exploration of city sights got tabled and we spent the majority of our time in the Prague 2/Staré Vršovice neighborhood. It was the closest to living like locals we'd gotten since Saigon, and we felt relaxed and happy staying put. Our coworking space, Impact Hub, was just a 7-minute walk from our apartment, and there were so many great restaurants and bars within walking distance that there was no reason to venture further. It hit nearly 100 degrees (by the way – no air conditioning anywhere) so I was doubly glad to sit back at sidewalk cafes with a glass or three of wine and soak up the sunshine.</div>
            )
        },
        {
            text: (
                <div>We did go on one-day excursion on a Monday, working the Sunday instead so we could avoid weekend crowds. Kutna Hora is a small town an hour east of Prague, home to a place so creepy and incredible it feels like a permanent Halloween display: Sedlec Ossuary, the "Bone Church." No one knows exactly why a monk started stacking up bones; one explanation is that the bones belong to victims of the Plague, when the cemetery was overrun with too many dead. A few centuries later when the chapel was falling into disrepair, a German noble family bought it and started arranging the bones into creepy but awesome formations (including the family crest, complete with a bird made of cracked scapula and ribs). I can't believe visitors are allowed to get so close to everything; there are skulls stacked everywhere that you could touch (if you wanted to… please don't.) We didn't manage to figure out the train system very well, though, and got yelled at by a comically irate Czech train lady. Luckily, the Czech guys behind her couldn't hold in their laughter at her overblown, ridiculous reaction, and we had to try hard to keep straight faces.</div>
            )
        },
        {
            text: (
                <div>I could have spent a month in this gorgeous city with its pastel, decorative buildings and devotion to sidewalk chill (I saw one guy at a little table on the sidewalk at 10 a.m. on a Thursday, sipping from a mini champagne bottle. Classy.) I'm sure I'll be back a fifth time at some point – but for now, it made me extremely excited to go out further east in our travels later this summer. Three more weeks of work until we relive the backpacker life in Eastern Europe!</div>
            )
        },
        {
            text: (
                <div>If any of you are planning on visiting in the future, I now have a very thorough list of recs to share! <a href="mailto:alicecamilleavery@gmail.com">Email me</a>.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague1.jpg',
            detailText:'Like a mini Grand Budapest hotel. Budapest and Prague were both part of the Austro Hungarian Empire up until then-Czechoslovakia gained independence in 1918. The area now part of the Czech Republic had boasted most of the empire\'s industrial output and several German-run factories, and was a lot wealthier than the Slovakian side.' 
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague2.jpg','https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague3.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague14.jpg',
            detailText:'Our lovely (and very warm) co-working space.'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague4.jpg','https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague5.jpg'],
            detailText:'Peter loves it when I\'m trying to get a specific camera shot ;)'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague6.jpg',
            detailText:'Charles Bridge at sunrise from the northeast bank, near Kafka Museum.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague7.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague9.jpg','https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague10.jpg'],
            detailText:'We spent 4 hours in Kutna Hora, with plenty of time to explore beyond the bone church. Left, the spectacularly gothic St. Barbara Cathedral.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague11.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague12.jpg','https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague13.jpg']
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague15.jpg','https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague16.jpg'],
            detailText:'On our last day, I visited the spectacular book display at the Municipal Library of Prague. The mirrors inside make it look several stories tall when you peer in.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/easternEurope/prague/prague17.jpg',
            detailText:'Kafka, but 21st century. This is one of David Cerny\'s moving sculptures. Another one which is quite cheeky feature two men peeing at each other while their butts swivel back and forth. Great fun while tailing a Russian tour group.'
        }
]
}


export default prague


// WEBPACK FOOTER //
// ./src/Posts/Content/prague.js